/* eslint-disable no-plusplus */
import { EVENT_MOUSE_MOVE } from '../settings';
import { Detector, MouseEventListenerCallback, OnDetectionCallback } from '../types';

class MouseMoveDetector<T> implements Detector<T> {
  onDetection: OnDetectionCallback<T>;

  elementUnderMousePointer: Element | null = null;

  mouseoverTimestamp: Map<Element, number> = new Map();

  eventListenerCallback: MouseEventListenerCallback | null = null;

  detectorStartTime: number | null = null;

  constructor(
    onDetection?: OnDetectionCallback<T>,
  ) {
    this.onDetection = (...args) => {
      onDetection?.apply(this, args);
    };
  }

  start() {
    if (this.eventListenerCallback) {
      return this;
    }
    this.detectorStartTime = Date.now();
    this.eventListenerCallback = (e: MouseEvent) => {
      const x = e.clientX;
      const y = e.clientY;

      const elementUnderPointer = document.elementFromPoint(x, y);
      if (!this.elementUnderMousePointer) {
        this.elementUnderMousePointer = elementUnderPointer;
      }
      if (elementUnderPointer && elementUnderPointer === this.elementUnderMousePointer) {
        this.mouseoverTimestamp.set(elementUnderPointer, Date.now());
      }
      if (
        this.detectorStartTime
        && elementUnderPointer
        && this.elementUnderMousePointer
        && elementUnderPointer !== this.elementUnderMousePointer
      ) {
        const mouseoverTimestamp = this.mouseoverTimestamp.get(this.elementUnderMousePointer);
        const duration = Date.now() - (mouseoverTimestamp ?? this.detectorStartTime);
        this.onDetection(
          elementUnderPointer,
          e,
          this.detectorStartTime,
          duration,
        );

        this.elementUnderMousePointer = elementUnderPointer;
      }
    };
    document.addEventListener(EVENT_MOUSE_MOVE, this.eventListenerCallback);
    return this;
  }

  stop() {
    if (this.eventListenerCallback) {
      document.removeEventListener(EVENT_MOUSE_MOVE, this.eventListenerCallback);
      this.eventListenerCallback = null;
      this.detectorStartTime = null;
    }
    return this;
  }
}

export default MouseMoveDetector;
